export default __webpack_public_path__ + "static/bottom-copy.url-5bd3779f84f83765433c9a2e92bff178.svg";